export default __webpack_public_path__ + "static/media/francheville14.97e26630.jpg";